import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const DownloadQRCodeSlide = () => {
    const androidLink = 'https://play.google.com/store/apps/details?id=com.assiganto';
    const iosLink = 'https://apps.apple.com/app/id000000000';

    return (
        <div
            className='d-flex flex-column align-items-center justify-content-center text-center p-3 fade-in-up'
            style={{ minHeight: '280px' }}
        >
            <h6 className='fw-bold mb-2'>Téléchargez l'application</h6>
            <p className='small text-muted mb-3'>Scannez pour installer</p>

            <div className='d-flex gap-4 justify-content-center flex-wrap fade-in-up'>
                <div className='d-flex flex-column align-items-center'>
                    <QRCodeCanvas value={androidLink} size={80} />
                    <span className='small mt-1'>Android</span>
                </div>
                <div className='d-flex flex-column align-items-center'>
                    <QRCodeCanvas value={iosLink} size={80} />
                    <span className='small mt-1'>iOS</span>
                </div>
            </div>

            <div className='d-flex gap-2 mt-3 flex-wrap justify-content-center fade-in-up'>
                <a href={androidLink} target='_blank' rel='noopener noreferrer'>
                    <img src="images/providers/GetItOnGooglePlay_Badge_Web_color_English.png" alt='Google Play' height='36' />
                </a>
                <a href={iosLink} target='_blank' rel='noopener noreferrer'>
                    <img src="images/providers/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt='App Store' height='36' />
                </a>
            </div>
        </div>
    );
};

export default DownloadQRCodeSlide;
